import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Calendar from '../../../Part_Sample/Calendar';
import { isEmpty, handleDownloadCSV, makeTimeString } from '../../../Common/Common';

import Chart_Bar from '../../../Part_Sample/Chart_Bar_Data_Analysis';

export default class PPD_Data_Analysis extends Component {
	constructor(props) {
		super(props);
		let date = new Date();
		//let from_date = new Date(date.getFullYear(), date.getMonth() - 1, 1);
		let from_date = new Date(date.getFullYear(), date.getMonth(), 1); //1st Day of this month
		//let to_date = new Date(date.getFullYear(), date.getMonth(), 0); //the last day of last month
		let to_date = new Date(date.getFullYear(), date.getMonth(), date.getDate()); //Today's date

		let rawData = {};
		let processedData = {};
		let chartData = {};
		let tempScrollTop = 0;

		if (!isEmpty(this.props.param)) {
			if (this.props.param.hasOwnProperty('rawData')) rawData = this.props.param.rawData;
			if (this.props.param.hasOwnProperty('processedData')) processedData = this.props.param.processedData;
			if (this.props.param.hasOwnProperty('chartData')) chartData = this.props.param.chartData;
			if (this.props.param.hasOwnProperty('scrollTop')) tempScrollTop = this.props.param.scrollTop;
			if (this.props.param.hasOwnProperty('fromDate')) from_date = this.props.param.fromDate;
			if (this.props.param.hasOwnProperty('toDate')) to_date = this.props.param.toDate;
		}

		this.state = {
			selected_from_date: from_date,
			selected_to_date: to_date,
			is_show_from_calendar: false, //show "from" calendar
			is_show_to_calendar: false, //show "to" calendar
			rawData: rawData,
			processedData: processedData,
			chartData: chartData,
			progress_status: '',
			scrollTop: parseInt(tempScrollTop)
		}

		this.chart = React.createRef();

		this.divRef = React.createRef();
	}

	componentDidMount() {
		this.divRef.current.scrollTop = this.state.scrollTop;
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('PPD_Data');
	}

	handleChangeToCalDate = (selected_date) => {
		let now = new Date();
		let check_date = new Date(selected_date);
		now.setHours(0, 0, 0);
		check_date.setHours(0, 0, 0);

		if (check_date > now) {
			this.setState({
				selected_to_date: now,
				is_show_to_calendar: false
			}, this.handleQuery);
		} else {
			this.setState({
				selected_to_date: selected_date,
				is_show_to_calendar: false
			}, this.handleQuery);
		}
	}

	handleChangeFromCalDate = (selected_date) => {
		let now = new Date();
		let check_date = new Date(selected_date);
		now.setHours(0, 0, 0);
		check_date.setHours(0, 0, 0);

		if (check_date > now) {
			this.setState({
				selected_from_date: now,
				is_show_from_calendar: false
			}, this.handleQuery);
		} else {
			this.setState({
				selected_from_date: selected_date,
				is_show_from_calendar: false
			}, this.handleQuery);
		}
	}

	toggleToCalendar = () => {
		this.setState({
			is_show_from_calendar: false,
			is_show_to_calendar: !this.state.is_show_to_calendar
		});
	}

	toggleFromCalendar = () => {
		this.setState({
			is_show_from_calendar: !this.state.is_show_from_calendar,
			is_show_to_calendar: false
		});
	}

	handleLeftButtonAction = () => {
		let from = new Date(this.state.selected_from_date);
		let to = new Date(this.state.selected_to_date);

		if (to.getTime() < from.getTime()) {
			window.app.showToast(this.props.receiver.getString('end_date_earlier_than_start_date'), 3000);
			return;
		}

		to.setDate(to.getDate() + 1);

		let timeDiff = to.getTime() - from.getTime();

		let daysDiff = timeDiff / (1000 * 3600 * 24);

		if (daysDiff > 31) {
			window.app.showToast(this.props.receiver.getString('start_date_end_date_one_month'), 3000);
			return;
		}

		window.app.showLoading();
		this.setState({ progress_status: this.props.receiver.getString('downloading_data') }, () => {
			this.props.receiver.loadPPDPointList();
		})
	}

	handleIDUHourlyChart = (pid) => {
		window.app.showLoading();

		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('IDU_Hourly_Chart', {
			pid: pid,
			rawData: this.state.rawData,
			processedData: this.state.processedData,
			chartData: this.state.chartData,
			scrollTop: this.divRef.current.scrollTop,
			fromDate: this.state.selected_from_date,
			toDate: this.state.selected_to_date
		});
	}

	rcvLoadPPDPointList = (ppd_point_list) => {
		if (ppd_point_list != null) {
			let from = new Date(this.state.selected_from_date);
			let to = new Date(this.state.selected_to_date);

			// {"fy":year,"fm":month,"fd":day,"ty":year,"tm":month,"td":day,"points":[ppd point id,…]}
			let param = {};
			param.fy = from.getFullYear();
			param.fm = from.getMonth() + 1;
			param.fd = from.getDate();
			param.ty = to.getFullYear();
			param.tm = to.getMonth() + 1;
			param.td = to.getDate() + 1;
			param.points = ppd_point_list;

			this.props.receiver.getPPD(param);
		} else {
			this.setState({ progress_status: '' });
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('no_ppd_points'), 3000);
		}
	}

	rcvGetPPD = (response) => {
		if (response.result != null) {
			if (response.result == 'NG') {
				this.setState({ progress_status: '' });
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('failed'), 3000);
				return;
			}
		}

		if (isEmpty(response.data)) {
			this.setState({ progress_status: '' });
			window.app.hideLoading();
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
			return;
		}

		this.setState({ progress_status: this.props.receiver.getString('processing') }, () => {
			// START Data Total all by ID START //
			let data = response.data;
			let id_list = Object.keys(data);

			let payload = {};

			for (let id of id_list) {
				let device_data = data[id];

				let cool = 0;
				let heat = 0;
				let standby = 0;
				let fan = 0;
				let heater = 0;

				for (let device_data_row of device_data) {
					cool = (parseFloat(cool) + device_data_row[1]).toFixed(3);
					heat = (parseFloat(heat) + device_data_row[2]).toFixed(3);
					standby = (parseFloat(standby) + device_data_row[3]).toFixed(3);
					fan = (parseFloat(fan) + device_data_row[4]).toFixed(3);
					heater = (parseFloat(heater) + device_data_row[5]).toFixed(3);
				}

				payload[id] = [cool, heat, standby, fan, heater];
			}
			// END Data Total all by ID END //

			// START Format for CHART START//
			let coolTotal = [this.props.receiver.getString('cool')];
			let heatTotal = [this.props.receiver.getString('heat')];
			let standbyTotal = [this.props.receiver.getString('standby')];
			let fanTotal = [this.props.receiver.getString('fan')];
			let heaterTotal = [this.props.receiver.getString('heater')];

			for (let id of id_list) {
				coolTotal.push(parseFloat(payload[id][0]));
				heatTotal.push(parseFloat(payload[id][1]));
				standbyTotal.push(parseFloat(payload[id][2]));
				fanTotal.push(parseFloat(payload[id][3]));
				heaterTotal.push(parseFloat(payload[id][4]));
			}
			// END Format for CHART END//

			this.setState({
				rawData: response.data,
				processedData: payload,
				chartData: [id_list, coolTotal, heatTotal, standbyTotal, fanTotal, heaterTotal],
				progress_status: ''
			});
			window.app.hideLoading();
		});
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			//overflow: 'auto',
		}
		
		let ppd_content_style = {
			overflow: 'auto',
			height: this.props.height - 50,
		}

		let cal_width = this.props.width - 40;
		let cal_height = 200;



		let chart_width = this.props.width - 10;
		//let chart_height = chart_width/3*2;
		let chart_height = 0;

		if (!isEmpty(this.state.chartData)) {
			if (!isEmpty(this.state.chartData[0])) {
				chart_height = this.state.chartData[0].length * 30;
			}
		}

		/*let is_landscape = (this.props.width >= this.props.height)
		if(is_landscape){
			chart_height = this.props.width/3;
			if(chart_height > this.props.height-240 && chart_height>250) chart_height = this.props.height - 240;
		}*/

		let is_show_calendar = false;

		if (this.state.is_show_from_calendar == true || this.state.is_show_to_calendar == true) {
			is_show_calendar = true;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar' ref={this.divRef}>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('ppd_data_analysis')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					
					<div style={ppd_content_style}>
						<div style={{ boxShadow: 'rgb(0 0 0 / 10%) 1px 1px 2px 2px', padding: 20, margin: 20, borderRadius: 20 }}>
							{/* From Date */}
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span style={{ display: 'block' }}>{this.props.receiver.getString("from")}</span>
								<div onClick={this.toggleFromCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
									<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_from_date.toLocaleDateString()}</span>
								</div>
							</div>

							{/* To Date */}
							<div style={{ display: 'inline-block', width: '50%' }}>
								<span style={{ display: 'block' }}>{this.props.receiver.getString("to")}</span>
								<div onClick={this.toggleToCalendar} style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-block', paddingTop: 5, textAlign: 'left' }}>
									<span className='title' style={{ textDecoration: 'underline' }}>{this.state.selected_to_date.toLocaleDateString()}</span>
								</div>
							</div>
						</div>

						<div style={{ width: this.props.width - 20, padding: '10px' }}>
							<span className='title'>{this.state.progress_status}</span>
						</div>

						<div id="toCalendar" className='slideInDown' style={{}}>
							<Calendar
								onSelect={this.handleChangeToCalDate}
								style={{ visibility: this.state.is_show_to_calendar ? 'visible' : 'hidden' }}
								width={cal_width}
								height={cal_height}
								left={(this.props.width - 20) * 0.05}
								max_date={new Date()}
								selected_date={this.state.selected_to_date}
							/>
						</div>

						<div id="fromCalendar" className='slideInDown' style={{}}>
							<Calendar
								onSelect={this.handleChangeFromCalDate}
								style={{ visibility: this.state.is_show_from_calendar ? 'visible' : 'hidden' }}
								width={cal_width}
								height={cal_height}
								left={(this.props.width - 20) * 0.05}
								max_date={new Date()}
								selected_date={this.state.selected_from_date}
							/>
						</div>

						{isEmpty(this.state.chartData) ? <div></div> : (
							<Chart_Bar
								style={{ zIndex: is_show_calendar ? -1 : 1, paddingBottom: '80px' }}
								id={'IDU_Total_Power'}
								ref={this.chart}
								title={this.props.receiver.getString('IDU_Total_Power') + ' (kWh)'}
								chart_width={chart_width}
								chart_height={chart_height}
								data={this.state.chartData}
								receiver={this.props.receiver}
								handleIDUHourlyChart={this.handleIDUHourlyChart}
							/>
						)}
					</div>
				</div>
			</div>
		)
	}
}